import React, { FC, useState, useMemo } from 'react';

import { TableCell, ClickAwayListener } from '@material-ui/core';
import { isWidthUp } from '@material-ui/core/withWidth';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import InfoIcon from '../../../../../assets/icons/InfoIcon';
import { LightTooltip } from '../../../../../components/UI/LightTooltip';
import { useWidth } from '../../../../../theme';
import { CellProps } from '../../../const';

const ArrayCell: FC<CellProps> = ({ row, k, styles, align }) => {
  const { t } = useTranslation();
  const width = useWidth();
  const isMobile = !isWidthUp('md', width);

  const [showTooltip, setShowTooltip] = useState(false);

  const arrayData = row[k];

  const firstItem = arrayData?.[0];
  const othersData = useMemo(() => (row[k] ? row[k].slice(1) : []), [row, k]);
  const title = useMemo(() => othersData.join(', '), [othersData]);

  return (
    <TableCell key={k} className={cx(styles.contentCell, styles.arrayCell)} align={align}>
      {firstItem}
      {Boolean(othersData?.length) &&
        (isMobile ? (
          <ClickAwayListener onClickAway={() => setShowTooltip(false)}>
            <LightTooltip
              open={showTooltip}
              title={title}
              classes={{ tooltip: styles.tooltip }}
              placement="right"
            >
              <div className={styles.othersText} onClick={() => setShowTooltip(true)}>
                {t('block.analyticsTable.othersCount', { count: othersData.length })}
                <InfoIcon className={styles.othersIcon} />
              </div>
            </LightTooltip>
          </ClickAwayListener>
        ) : (
          <LightTooltip title={title} classes={{ tooltip: styles.tooltip }} placement="right">
            <div className={styles.othersText}>
              {t('block.analyticsTable.othersCount', { count: othersData.length })}
              <InfoIcon className={styles.othersIcon} />
            </div>
          </LightTooltip>
        ))}
    </TableCell>
  );
};

export default ArrayCell;
